export interface HcVoice {
  _id?: string; // MongoDB document ID
  languageLocale: string;
  languageCode: string;
  language: string;
  type: VoiceType;
  gender: VoiceGender;
  provider: VoiceProvider;
  voice: string;
  /** Readable label for UI; when unset, clients should display `voice` (provider voice id). */
  voiceNameLabel?: string | null;
  enabled?: boolean; // Defaults to true for backward compatibility. Controls whether voice is available to non-admin users.
  playbackDisabled?: boolean; // Defaults to false for backward compatibility. Indicates voice does not support playback/preview.
}

export enum VoiceType {
  STANDARD = 'voice.type.standard',
  NEURAL = 'voice.type.neural',
  GENERATIVE = 'voice.type.generative',
  BASIC = 'voice.type.basic'
}

export enum VoiceGender {
  FEMALE = 'voice.gender.female',
  MALE = 'voice.gender.male',
  FEMALE_CHILD = 'voice.gender.female_child',
  MALE_CHILD = 'voice.gender.male_child'
}

export enum VoiceProvider {
  GOOGLE = 'voice.provider.google',
  POLLY = 'voice.provider.polly',
  NONE = 'voice.provider.none'
}
